import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { FlowManager } from '../flow-management/FlowManager';
import { setNextStep } from '../flow-management/setNextStep';
import { isPreVerification } from '../flow-settings/settingsSelectors';
import { redirectExistingUserAction } from '../store/auth/action-creators';
import { AuthActionTypes } from '../store/auth/action-types';
import { fetchExistingAccounts } from '../store/existing-accounts/action-creators';
import { getNextSteps, getPostExistingAccountSelectionSteps } from '../store/flow/selectors';
export const ExistingUserMiddleware = store => next => action => {
  if ((action.type === AuthActionTypes.InitializeAuth && action.isAuthenticated || action.type === AuthActionTypes.ExistingOAuthUser) && isPreVerification()) {
    store.dispatch(fetchExistingAccounts());
  }

  if (action.type === AuthActionTypes.PortalSelected) {
    const state = store.getState();
    const postExistingAccountSelection = getPostExistingAccountSelectionSteps(state);
    const nextSteps = getNextSteps(state);
    const shouldRedirectExistingUserAutomatically = getFlowConfig().shouldRedirectExistingUserAutomatically;

    if (postExistingAccountSelection.length > 0) {
      store.dispatch(setNextStep({
        rebuilder: FlowManager.pushNextAndRemove(postExistingAccountSelection, nextSteps.filter(data => !postExistingAccountSelection.includes(data)))
      }));
    } else if (shouldRedirectExistingUserAutomatically) {
      store.dispatch(redirectExistingUserAction(action.payload));
    }
  }

  return next(action);
};